import { C_Vat_Code } from '../../../../../../../graphql/generatedModel';

export const heuristicVATDetection = (raw: string): C_Vat_Code | undefined => {
  const input = raw.trim();

  if (!input) return undefined;

  const code = detectVatEnum(input);
  if (code) return code;

  const s = clean(input);
  if (isZeroLike(s)) return C_Vat_Code.VT5_ZERO;
  if (isNormalLike(s)) return C_Vat_Code.VT1_NORMAL;

  return undefined;
};

const clean = (s: string): string =>
  s
    .trim()
    .replace(/^['"](.*)['"]$/, '$1')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[.,;:()[\]]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const isZeroLike = (s: string): boolean =>
  /\b(0|zero|steuerfrei|ohne\s*(mwst|ust)|exempt|tax\s*free|sans\s*tva|hors\s*tva|esente|senza\s*iva|non\s*imponibile)\b/.test(
    s,
  );

const isNormalLike = (s: string): boolean =>
  /\b(normal(rate)?|normalsatz|standard|taux\s*normal|aliquota\s*normale)\b/.test(s);

const isReducedLike = (s: string): boolean =>
  /\b(reduced|erm[aä]ssig(?:t)?|reduziert(?:er)?(?:\s*satz)?|taux\s*reduit|aliquota\s*ridott[ao])\b/.test(
    s,
  ) ||
  (/\b(red|rid)\b/.test(s) && /\b(vat|mwst|ust|umsatzsteuer|tva|iva)\b/.test(s));

const isSpecial1Like = (s: string): boolean =>
  /\b(special\s*1|spezial\s*1|sp[ée]cial\s*1|speciale\s*1)\b/.test(s);

const isSpecial2Like = (s: string): boolean =>
  /\b(special\s*2|spezial\s*2|sp[ée]cial\s*2|speciale\s*2)\b/.test(s);

const containsVatToken = (s: string): boolean => /\b(vat|mwst|ust|umsatzsteuer|tva|iva)\b/.test(s);

const detectVatEnum = (raw: string): C_Vat_Code | null => {
  const s = clean(raw);

  if (isSpecial2Like(s)) return C_Vat_Code.VT4_SPECIAL2;
  if (isSpecial1Like(s)) return C_Vat_Code.VT3_SPECIAL1;
  if (isReducedLike(s)) return C_Vat_Code.VT2_REDUCED;
  if (isNormalLike(s)) return C_Vat_Code.VT1_NORMAL;
  if (isZeroLike(s)) return C_Vat_Code.VT5_ZERO;

  if (containsVatToken(s)) {
    if (/\b(spezial|special|sp[ée]cial|speciale)\b/.test(s)) return C_Vat_Code.VT3_SPECIAL1;
    if (/\b(standard|default|base|basique|regulier|regular|norm)\b/.test(s))
      return C_Vat_Code.VT1_NORMAL;
  }

  return null;
};
